import PlaylistEntries from '../../models/PlaylistEntries'
import { getPlaylistEntry } from '../selectors/playlistEntries'
import { setDisplayedPlaylistEntriesOrder } from '../actions/playlists'

export const PLAYLIST_ENTRY_CREATED = 'PLAYLIST_ENTRY_CREATED'
export const START_PLAYLIST_ENTRY_SORT = 'START_PLAYLIST_ENTRY_SORT'
export const PLAYLIST_ENTRY_DELETED = 'PLAYLIST_ENTRY_DELETED'

export function startPlaylistEntrySort (uuid, sortedEntryObj) {
  return {
    type: START_PLAYLIST_ENTRY_SORT,
    uuid,
    sortedEntryObj
  }
}

export function playlistEntryDeleted (playlistEntryId) {
  return {
    type: PLAYLIST_ENTRY_DELETED,
    playlistEntryId
  }
}

export function playlistEntryCreated (playlistUUID, planEntryId, createdAt) {
  return {
    type: PLAYLIST_ENTRY_CREATED,
    playlistUUID,
    planEntryId,
    createdAt
  }
}

export function createNewPlaylistEntry (playlistUUID, planEntryId) {
  return dispatch => {
    PlaylistEntries.createNew(playlistUUID, planEntryId).then(res => {
      dispatch(
        playlistEntryCreated(playlistUUID, planEntryId, res.data.createdAt)
      )
    })
  }
}

export function sortPlaylistEntries (playlist, sortedEntryIds, e) {
  return dispatch => {
    playlist.sort(sortedEntryIds)

    dispatch(setDisplayedPlaylistEntriesOrder())
    dispatch(startPlaylistEntrySort(playlist.uuid, e))
  }
}

export function deletePlaylistEntry (playlistEntryId) {
  return (dispatch, getState) => {
    const state = getState()
    const playlistEntry = getPlaylistEntry(state, playlistEntryId)
    playlistEntry.deleteEntry().then(() => {
      dispatch(playlistEntryDeleted(playlistEntryId))
    })
  }
}
